import { Link } from 'react-router-dom';

const policyItems = [
  '收集資料：為處理訂單及提供服務，本店可能收集你的姓名、聯絡電話、送貨地址、屋苑名稱及訂單內容。',
  '使用目的：資料只用於安排配送、客戶服務、訂單通知及改善服務。',
  '資料分享：我們不會出售你的個人資料。資料可能與配送合作方及 WhatsApp 發送服務商共享，僅限完成服務所需範圍。',
  '資料保留：我們會按香港法律要求保留交易記錄，其餘資料在完成用途後會適時刪除。',
  '聯絡我們：如有私隱疑問，請透過 WhatsApp +852 6077 1493 聯絡。',
  '修訂：本政策可能不時更新，請定期查閱。',
];

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8 px-4 sm:px-6 lg:px-8 transition-colors">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 md:p-10 transition-colors">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-2">
            阿力廚房 Alex Kitchen
          </h1>
          <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-200 mb-6">
            私隱政策
          </h2>

          <ol className="list-decimal pl-5 space-y-4 text-gray-700 dark:text-gray-300 leading-relaxed">
            {policyItems.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ol>

          <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
            <Link
              to="/"
              className="inline-flex items-center text-orange-600 hover:text-orange-700 dark:text-orange-400 dark:hover:text-orange-300 font-medium"
            >
              ← 返回首頁
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
